// extracted by mini-css-extract-plugin
export default {"createTemplatePopup":"TemplateManagment_createTemplatePopup__RoyG3","createTemplatePopup__field":"TemplateManagment_createTemplatePopup__field__V01Vy"};